import { executeMutation, executeQuery } from "utils/services/apiServices";
import { actionTypes, CreatePermissionInput, PermissionProp } from "./actionType";
import { showSnackbar } from "utils/snack_bar/store/action";
import { FETCH_ALL_PERMISSIONS } from "../graphql/query";
import { SET_PERMISSION } from "../graphql/mutation";

export const fetchPermissionRequest = () => ({
  type: actionTypes.FETCH_PERMISSION_REQUEST,
});

export const fetchPermissionSuccess = (payload: PermissionProp[]) => ({
  type: actionTypes.FETCH_PERMISSION_SUCCESS,
  payload,
});

export const fetchPermissionFail = (payload: string) => ({
  type: actionTypes.FETCH_PERMISSION_FAIL,
  payload,
});

export const fetchPermission = (limit: number, offset: number) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchPermissionRequest());
      const response = await executeQuery(FETCH_ALL_PERMISSIONS, { limit, offset});
      const jsonData = response.data?.fetchAllPermissions;
      if (jsonData?.error === null) {
        dispatch(fetchPermissionSuccess(jsonData?.data.permission));
      } else {
        dispatch(fetchPermissionFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchPermissionFail("Failed to fetch fetchRole(s)"));
    }
  };
};

//create role
export const setPermissionRequest = () => ({
  type: actionTypes.SET_PERMISSION_REQUEST,
});

export const setPermissionSuccess = (payload: PermissionProp[]) => ({
  type: actionTypes.SET_PERMISSION_SUCCESS,
  payload,
});

export const setPermissionFail = (payload: string) => ({
  type: actionTypes.SET_PERMISSION_FAIL,
  payload,
});

export const setPermission = (input:CreatePermissionInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(setPermissionRequest());
      const response = await executeMutation(SET_PERMISSION, { input });
      const jsonData = response.data?.setPermissions;
      if (jsonData?.error === null) {
        dispatch(setPermissionSuccess(jsonData?.data.permission));
        dispatch(showSnackbar('Success! permission created.'));
      } else {
        dispatch(setPermissionFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message? jsonData.error.message : "Fail to create."}`));
      }
    } catch (error: any) {
      dispatch(setPermissionFail("Failed to create permission"));
    }
  };
};

//RESET
export const ResetPermission = () => ({
  type: actionTypes.RESET_PERMISSION,
});

export const resetPermission = () => {
  return async (dispatch: any) => {
    dispatch(ResetPermission());
  };
};